import { api } from "@/lib/api"

/** Lo que devuelve el alta. Ver `backend/app/modules/auth/registro.py`. */
export interface AltaDeEmpresa {
  tenant_id: string
  slug: string
  nombre: string
  rol: string
  plan_gerencial: number
  mapeo: number
  reglas_tratamiento: number
  siguiente: string
}

/**
 * Da de alta la empresa de quien está en sesión.
 *
 * VA DESPUÉS DE CREAR LA IDENTIDAD, y no a la vez: el backend necesita un token
 * de Firebase verificado para saber a quién asignar el rol. De ahí que el
 * registro sean dos pasos y no uno, y que el orden importe.
 */
export function darDeAltaEmpresa(empresa: string, nombre?: string) {
  return api.post<AltaDeEmpresa>("/auth/registro", {
    empresa,
    nombre: nombre?.trim() || null,
  })
}
